import React from 'react';
import AutoparaPython from './AutoparaPython';
import AutoparaJava from './AutoparaJava';
import AutoparaCloud from './AutoparaCloud';

import AutoparaCommunication from './AutoparaCommunication';
import AutoparaSkillDevelopment from './AutoparaSkillDevelopment';
import AutoparaCustomerCare from './AutoparaCustomerCare';
import AutoparaBPO from './AutoparaBPO';
import AutoparaHR from './AutoparaHR';

function TechServicesPage() {
  return (
    <div className="space-y-20">
      {/* IT Courses */}
      <AutoparaPython />
      <AutoparaJava />
      <AutoparaCloud />

      {/* Non-IT Courses */}
      <AutoparaSkillDevelopment />
      <AutoparaCustomerCare />
      <AutoparaBPO />
      <AutoparaHR />
      <AutoparaCommunication />
    </div>
  );
}

export default TechServicesPage;
